var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoonActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.548 1.492a6 6 0 007.96 7.96A6.669 6.669 0 011.333 8a6.669 6.669 0 015.215-6.508zm5.562.035l.557.14v.666l-.557.14a1.333 1.333 0 00-.97.97L11 4h-.666l-.14-.557a1.334 1.334 0 00-.97-.97l-.557-.14v-.666l.557-.14a1.333 1.333 0 00.97-.97l.14-.557H11l.14.557a1.333 1.333 0 00.97.97zm3.333 3.334L16 5v.667l-.557.139a1.334 1.334 0 00-.97.97l-.14.557h-.666l-.14-.557a1.333 1.333 0 00-.97-.97L12 5.666V5l.557-.14a1.333 1.333 0 00.97-.97l.14-.557h.667l.139.558a1.334 1.334 0 00.97.97z",
    fill: "#fff"
  })));
}
export default __webpack_public_path__ + "static/svg/light-mode/moon-active.svg";
export { SvgMoonActive as ReactComponent };